export const IMAGE_FORMATS = ['tiff']
